import { render, staticRenderFns } from "./NicknameForm.vue?vue&type=template&id=a0d1081e&scoped=true&"
import script from "./NicknameForm.vue?vue&type=script&lang=js&"
export * from "./NicknameForm.vue?vue&type=script&lang=js&"
import style0 from "./NicknameForm.vue?vue&type=style&index=0&id=a0d1081e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0d1081e",
  null
  
)

export default component.exports